import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[clearOnFocus]'
})
export class ClearOnForcusDirective {

    @Input()
    public newAreaNamePlaceHolder?: string;

    @Output()
    public onFocusChanged: EventEmitter<any> = new EventEmitter();

    @HostListener('focus', ['$event'])
    public onFocus(evt: Event) {
        const input = evt.target as HTMLInputElement;
        if (this.newAreaNamePlaceHolder && this.newAreaNamePlaceHolder === input.value) {
            input.value = '';
            this.onFocusChanged.emit(null);
        }
    }

}
